import { replace } from 'lodash';
import i18n, { i18nKeyType } from '../../i18n';

export function i18nPlanName(name: string): string {
  return i18n.t(`plan:plan_name_${name}` as i18nKeyType);
}

export function i18nPlanNameBySku(sku: string): string {
  return i18n.t(
    `plan:plan_sku_${replace(sku, '-', '_').toLowerCase()}` as i18nKeyType
  );
}

export function i18nPlanDescription(name: string): string {
  return i18n.t(`plan:plan_description_${name}` as i18nKeyType);
}
